/** The amoeba (docs/spec/02 §7.1): grows at random, then turns to diamonds or boulders. */

import { AMOEBA_EATS, CDX, CDY, E } from '../elements';
import { at, put, store } from '../grid';
import { RULES } from '../tuning';
import type { CaveState } from '../types';

function canGrow(s: CaveState, x: number, y: number): boolean {
  for (let d = 0; d < 4; d++) {
    if (AMOEBA_EATS[at(s, x + (CDX[d] ?? 0), y + (CDY[d] ?? 0))] === 1) return true;
  }
  return false;
}

/** Slow for `amoebaTime` seconds after Digby's birth, fast after (and before birth: slow). */
function growthChance(s: CaveState): number {
  const slowMs = s.params.amoebaTime * 1000;
  const fast = s.bornMs >= 0 && s.ms - s.bornMs >= slowMs;
  return fast ? RULES.amoebaFast : RULES.amoebaSlow;
}

export function amoeba(s: CaveState, x: number, y: number): void {
  const a = s.amoeba;
  if (a.phase === 'tooBig') {
    put(s, x, y, E.BOULDER);
    return;
  }
  if (a.phase === 'enclosed') {
    put(s, x, y, E.DIAMOND);
    return;
  }
  a.count++;
  if (!a.canGrow && canGrow(s, x, y)) a.canGrow = true;
  if (s.rng.int(128) >= growthChance(s)) return;
  const d = s.rng.int(4);
  const nx = x + (CDX[d] ?? 0);
  const ny = y + (CDY[d] ?? 0);
  if (AMOEBA_EATS[at(s, nx, ny)] === 1) {
    store(s, nx, ny, E.AMOEBA);
    a.growing = true;
  }
}

/** After the scan: decide whether the amoeba is enclosed or too big. */
export function amoebaEndOfScan(s: CaveState): void {
  const a = s.amoeba;
  if (a.phase === 'sleeping' || a.phase === 'awake') {
    if (a.count > 0) {
      if (a.count >= RULES.amoebaMax) a.phase = 'tooBig';
      else if (!a.canGrow) a.phase = 'enclosed';
      else a.phase = 'awake';
    }
  }
  a.size = a.count;
  a.count = 0;
  a.canGrow = false;
}
